(() => {
  if (window.__productSizeFinderModalLoaded) return;
  window.__productSizeFinderModalLoaded = true;

  const MODAL_SELECTOR = "[data-product-size-finder-modal]";
  const OPEN_SELECTOR = "[data-product-size-finder-open]";
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const MEASUREMENTS = {
    overBust: { label: "Over Bust", placeholder: "Enter your over bust" },
    underBust: { label: "Under Bust", placeholder: "Enter your under bust" },
    waist: { label: "Waist", placeholder: "Enter your waist" },
    hips: { label: "Hips", placeholder: "Enter your hips" },
    length: { label: "Length", placeholder: "Enter your length" },
    cup: { label: "Cup Size", placeholder: "Select your cup size" },
  };

  const CUP_LETTERS = ["A", "B", "C", "D", "DD", "E", "F"];

  const PRODUCT_CONFIGS = {
    "deep-v-waist-smoothing-catsuit": {
      category: "bodysuits",
      requiredMeasurements: ["overBust", "waist", "length"],
      sizeChart: [
        { size: "XS/S", overBust: [32, 35], waist: [25, 27], length: [48.4, 48.4], unit: "in" },
        { size: "M/L", overBust: [36, 39], waist: [28, 31], length: [49.2, 49.2], unit: "in" },
        { size: "XL/XXL", overBust: [40, 44], waist: [32, 35], length: [50, 50], unit: "in" },
        { size: "3XL/4XL", overBust: [45, 48], waist: [36, 40], length: [50.8, 50.8], unit: "in" },
        { size: "XS/S", overBust: [81, 89], waist: [64, 69], length: [123, 123], unit: "cm" },
        { size: "M/L", overBust: [91, 99], waist: [71, 79], length: [125, 125], unit: "cm" },
        { size: "XL/XXL", overBust: [102, 112], waist: [81, 89], length: [127, 127], unit: "cm" },
        { size: "3XL/4XL", overBust: [114, 122], waist: [91, 102], length: [129, 129], unit: "cm" },
      ],
    },
    "high-waisted-tummy-sculpting-brief": {
      category: "underwear",
      requiredMeasurements: ["waist", "hips"],
      sizeChart: [
        { size: "S", waist: [26, 28], hips: [36, 38], unit: "in" },
        { size: "M", waist: [28, 30], hips: [38, 40], unit: "in" },
        { size: "L", waist: [30.5, 32.5], hips: [40, 42], unit: "in" },
        { size: "XL", waist: [33.5, 36], hips: [42.5, 45], unit: "in" },
        { size: "XXL", waist: [37, 39.5], hips: [45.5, 48], unit: "in" },
        { size: "3XL", waist: [40, 42.5], hips: [48.5, 51], unit: "in" },
        { size: "S", waist: [66, 71], hips: [91, 97], unit: "cm" },
        { size: "M", waist: [71, 76], hips: [97, 102], unit: "cm" },
        { size: "L", waist: [77, 83], hips: [102, 107], unit: "cm" },
        { size: "XL", waist: [85, 91], hips: [108, 114], unit: "cm" },
        { size: "XXL", waist: [94, 100], hips: [116, 122], unit: "cm" },
        { size: "3XL", waist: [102, 108], hips: [123, 130], unit: "cm" },
      ],
    },
    "sculpt-support-tank": {
      category: "tanks-camis",
      requiredMeasurements: ["overBust", "waist"],
      sizeChart: [
        { size: "S", overBust: [36, 38], waist: [28, 30], unit: "in" },
        { size: "M", overBust: [39, 41], waist: [31, 33], unit: "in" },
        { size: "L", overBust: [42, 44], waist: [34, 36], unit: "in" },
        { size: "XL", overBust: [45, 47], waist: [37, 39], unit: "in" },
        { size: "2XL", overBust: [49, 51], waist: [40, 42], unit: "in" },
        { size: "3XL", overBust: [52, 54], waist: [43, 45], unit: "in" },
        { size: "S", overBust: [91, 97], waist: [71, 76], unit: "cm" },
        { size: "M", overBust: [99, 104], waist: [79, 84], unit: "cm" },
        { size: "L", overBust: [107, 112], waist: [86, 91], unit: "cm" },
        { size: "XL", overBust: [114, 119], waist: [94, 99], unit: "cm" },
        { size: "2XL", overBust: [124, 130], waist: [102, 107], unit: "cm" },
        { size: "3XL", overBust: [132, 137], waist: [109, 114], unit: "cm" },
      ],
    },
    "lace-trim-shaping-bodysuit": {
      category: "bodysuits",
      requiredMeasurements: ["overBust", "waist", "hips"],
      sizeChart: [
        { size: "XS/S", overBust: [32, 35], waist: [25, 27], hips: [32, 35], unit: "in" },
        { size: "M/L", overBust: [36, 39], waist: [28, 31], hips: [36, 40], unit: "in" },
        { size: "XL/XXL", overBust: [40, 44], waist: [32, 35], hips: [41, 45], unit: "in" },
        { size: "3XL/4XL", overBust: [45, 48], waist: [36, 40], hips: [46, 50], unit: "in" },
        { size: "XS/S", overBust: [81, 89], waist: [64, 69], hips: [81, 89], unit: "cm" },
        { size: "M/L", overBust: [91, 99], waist: [71, 79], hips: [91, 102], unit: "cm" },
        { size: "XL/XXL", overBust: [102, 112], waist: [81, 89], hips: [104, 114], unit: "cm" },
        { size: "3XL/4XL", overBust: [114, 122], waist: [91, 102], hips: [117, 127], unit: "cm" },
      ],
    },
    "v-neck-contour-top": {
      category: "tanks-camis",
      requiredMeasurements: ["overBust", "waist", "hips"],
      sizeChart: [
        { size: "XS", overBust: [33, 35], waist: [25, 27], hips: [35, 37], unit: "in" },
        { size: "S", overBust: [36, 38], waist: [28, 30], hips: [38, 40], unit: "in" },
        { size: "M", overBust: [39, 41], waist: [31, 33], hips: [41, 43], unit: "in" },
        { size: "L", overBust: [42, 44], waist: [34, 36], hips: [44, 46], unit: "in" },
        { size: "XL", overBust: [45, 47], waist: [37, 39], hips: [47, 49], unit: "in" },
        { size: "2XL", overBust: [49, 51], waist: [40, 42], hips: [50, 52], unit: "in" },
        { size: "3XL", overBust: [52, 54], waist: [43, 45], hips: [53, 55], unit: "in" },
        { size: "XS", overBust: [84, 89], waist: [64, 69], hips: [89, 94], unit: "cm" },
        { size: "S", overBust: [91, 97], waist: [71, 76], hips: [97, 102], unit: "cm" },
        { size: "M", overBust: [99, 104], waist: [79, 84], hips: [104, 109], unit: "cm" },
        { size: "L", overBust: [107, 112], waist: [86, 91], hips: [112, 117], unit: "cm" },
        { size: "XL", overBust: [114, 119], waist: [94, 99], hips: [119, 124], unit: "cm" },
        { size: "2XL", overBust: [124, 130], waist: [102, 107], hips: [127, 132], unit: "cm" },
        { size: "3XL", overBust: [132, 137], waist: [109, 114], hips: [135, 140], unit: "cm" },
      ],
    },
    "staylift-strapless-bra": {
      category: "bras",
      requiredMeasurements: ["overBust", "underBust"],
      sizeChart: [
        { size: "30C", underBust: [25, 26], overBust: [29, 31], unit: "in" },
        { size: "30D", underBust: [25, 26], overBust: [30, 32], unit: "in" },
        { size: "32B", underBust: [27, 28], overBust: [29, 31], unit: "in" },
        { size: "32C", underBust: [27, 28], overBust: [30, 32], unit: "in" },
        { size: "32D", underBust: [27, 28], overBust: [31, 33], unit: "in" },
        { size: "32DD", underBust: [27, 28], overBust: [32, 34], unit: "in" },
        { size: "34B", underBust: [29, 30], overBust: [31, 33], unit: "in" },
        { size: "34C", underBust: [29, 30], overBust: [32, 34], unit: "in" },
        { size: "34D", underBust: [29, 30], overBust: [33, 35], unit: "in" },
        { size: "34DD", underBust: [29, 30], overBust: [34, 36], unit: "in" },
        { size: "36B", underBust: [31, 32], overBust: [33, 35], unit: "in" },
        { size: "36C", underBust: [31, 32], overBust: [34, 36], unit: "in" },
        { size: "36D", underBust: [31, 32], overBust: [35, 37], unit: "in" },
        { size: "36DD", underBust: [31, 32], overBust: [36, 38], unit: "in" },
        { size: "38B", underBust: [33, 34], overBust: [35, 37], unit: "in" },
        { size: "38C", underBust: [33, 34], overBust: [36, 38], unit: "in" },
        { size: "38D", underBust: [33, 34], overBust: [37, 39], unit: "in" },
        { size: "38DD", underBust: [33, 34], overBust: [38, 40], unit: "in" },
        { size: "40C", underBust: [35, 36], overBust: [38, 40], unit: "in" },
        { size: "40D", underBust: [35, 36], overBust: [39, 41], unit: "in" },
        { size: "42C", underBust: [37, 38], overBust: [40, 42], unit: "in" },
        { size: "42D", underBust: [37, 38], overBust: [41, 43], unit: "in" },
        { size: "44C", underBust: [39, 40], overBust: [42, 44], unit: "in" },
        { size: "44D", underBust: [39, 40], overBust: [43, 45], unit: "in" },
        { size: "30C", underBust: [64, 66], overBust: [74, 79], unit: "cm" },
        { size: "30D", underBust: [64, 66], overBust: [76, 81], unit: "cm" },
        { size: "32B", underBust: [69, 71], overBust: [74, 79], unit: "cm" },
        { size: "32C", underBust: [69, 71], overBust: [76, 81], unit: "cm" },
        { size: "32D", underBust: [69, 71], overBust: [79, 84], unit: "cm" },
        { size: "32DD", underBust: [69, 71], overBust: [81, 86], unit: "cm" },
        { size: "34B", underBust: [74, 76], overBust: [79, 84], unit: "cm" },
        { size: "34C", underBust: [74, 76], overBust: [81, 86], unit: "cm" },
        { size: "34D", underBust: [74, 76], overBust: [84, 89], unit: "cm" },
        { size: "34DD", underBust: [74, 76], overBust: [86, 91], unit: "cm" },
        { size: "36B", underBust: [79, 81], overBust: [84, 89], unit: "cm" },
        { size: "36C", underBust: [79, 81], overBust: [86, 91], unit: "cm" },
        { size: "36D", underBust: [79, 81], overBust: [89, 94], unit: "cm" },
        { size: "36DD", underBust: [79, 81], overBust: [91, 97], unit: "cm" },
        { size: "38B", underBust: [84, 86], overBust: [89, 94], unit: "cm" },
        { size: "38C", underBust: [84, 86], overBust: [91, 97], unit: "cm" },
        { size: "38D", underBust: [84, 86], overBust: [94, 99], unit: "cm" },
        { size: "38DD", underBust: [84, 86], overBust: [97, 102], unit: "cm" },
        { size: "40C", underBust: [89, 91], overBust: [97, 102], unit: "cm" },
        { size: "40D", underBust: [89, 91], overBust: [99, 104], unit: "cm" },
        { size: "42C", underBust: [94, 97], overBust: [102, 107], unit: "cm" },
        { size: "42D", underBust: [94, 97], overBust: [104, 109], unit: "cm" },
        { size: "44C", underBust: [99, 102], overBust: [107, 112], unit: "cm" },
        { size: "44D", underBust: [99, 102], overBust: [109, 114], unit: "cm" },
      ],
    },
    "strapless-mid-thigh-shaper-bodysuit": {
      category: "bodysuits",
      requiredMeasurements: ["overBust", "waist", "hips"],
      sizeChart: [
        { size: "S", overBust: [34, 36], waist: [28, 30], hips: [38, 40], unit: "in" },
        { size: "M", overBust: [36, 38], waist: [31, 33], hips: [41, 43], unit: "in" },
        { size: "L", overBust: [38, 40], waist: [34, 36], hips: [44, 46], unit: "in" },
        { size: "XL", overBust: [40, 42], waist: [37, 39], hips: [47, 49], unit: "in" },
        { size: "XXL", overBust: [42, 44], waist: [40, 42], hips: [50, 52], unit: "in" },
        { size: "3XL", overBust: [44, 46], waist: [43, 45], hips: [53, 55], unit: "in" },
        { size: "S", overBust: [86, 91], waist: [71, 76], hips: [97, 102], unit: "cm" },
        { size: "M", overBust: [91, 97], waist: [79, 84], hips: [104, 109], unit: "cm" },
        { size: "L", overBust: [97, 102], waist: [86, 91], hips: [112, 117], unit: "cm" },
        { size: "XL", overBust: [102, 107], waist: [94, 99], hips: [119, 124], unit: "cm" },
        { size: "XXL", overBust: [107, 112], waist: [102, 107], hips: [127, 132], unit: "cm" },
        { size: "3XL", overBust: [112, 117], waist: [109, 114], hips: [135, 140], unit: "cm" },
      ],
    },
    "sculptlift-underwire-thong-bodysuit": {
      category: "bodysuits",
      requiredMeasurements: ["overBust", "waist", "hips"],
      sizeChart: [
        { size: "S", overBust: [33.9, 35.4], waist: [26, 28.3], hips: [35.4, 37.8], unit: "in" },
        { size: "M", overBust: [35.4, 37.8], waist: [28.3, 30.7], hips: [37.8, 40.2], unit: "in" },
        { size: "L", overBust: [37.8, 40.2], waist: [30.7, 33.1], hips: [40.2, 42.5], unit: "in" },
        { size: "XL", overBust: [40.2, 42.5], waist: [33.1, 35.4], hips: [42.5, 44.9], unit: "in" },
        { size: "XXL", overBust: [42.5, 44.9], waist: [35.4, 37.8], hips: [44.9, 47.2], unit: "in" },
        { size: "3XL", overBust: [44.9, 47.2], waist: [37.8, 40.2], hips: [47.2, 49.6], unit: "in" },
        { size: "S", overBust: [86, 90], waist: [66, 72], hips: [90, 96], unit: "cm" },
        { size: "M", overBust: [90, 96], waist: [72, 78], hips: [96, 102], unit: "cm" },
        { size: "L", overBust: [96, 102], waist: [78, 84], hips: [102, 108], unit: "cm" },
        { size: "XL", overBust: [102, 108], waist: [84, 90], hips: [108, 114], unit: "cm" },
        { size: "XXL", overBust: [108, 114], waist: [90, 96], hips: [114, 120], unit: "cm" },
        { size: "3XL", overBust: [114, 120], waist: [96, 102], hips: [120, 126], unit: "cm" },
      ],
    },
    "zip-up-full-bust-mid-thigh-shaper-bodysuit": {
      category: "bodysuits",
      requiredMeasurements: ["overBust", "waist", "hips"],
      sizeChart: [
        { size: "S", overBust: [34, 36], waist: [28, 30], hips: [38, 40], unit: "in" },
        { size: "M", overBust: [36, 38], waist: [31, 33], hips: [41, 43], unit: "in" },
        { size: "L", overBust: [38, 40], waist: [34, 36], hips: [44, 46], unit: "in" },
        { size: "XL", overBust: [40, 42], waist: [37, 39], hips: [47, 49], unit: "in" },
        { size: "XXL", overBust: [42, 44], waist: [40, 42], hips: [50, 52], unit: "in" },
        { size: "3XL", overBust: [44, 46], waist: [43, 45], hips: [53, 55], unit: "in" },
        { size: "S", overBust: [86, 91], waist: [71, 76], hips: [97, 102], unit: "cm" },
        { size: "M", overBust: [91, 97], waist: [79, 84], hips: [104, 109], unit: "cm" },
        { size: "L", overBust: [97, 102], waist: [86, 91], hips: [112, 117], unit: "cm" },
        { size: "XL", overBust: [102, 107], waist: [94, 99], hips: [119, 124], unit: "cm" },
        { size: "XXL", overBust: [107, 112], waist: [102, 107], hips: [127, 132], unit: "cm" },
        { size: "3XL", overBust: [112, 117], waist: [109, 114], hips: [135, 140], unit: "cm" },
      ],
    },
    "lift-mid-thigh-shaper-shorts": {
      category: "underwear",
      requiredMeasurements: ["waist", "hips"],
      sizeChart: [
        { size: "S", waist: [26, 28], hips: [36, 38], unit: "in" },
        { size: "M", waist: [28, 30], hips: [38, 40], unit: "in" },
        { size: "L", waist: [30.5, 32.5], hips: [40, 42], unit: "in" },
        { size: "XL", waist: [33.5, 36], hips: [42.5, 45], unit: "in" },
        { size: "XXL", waist: [37, 39.5], hips: [45.5, 48], unit: "in" },
        { size: "3XL", waist: [40, 42.5], hips: [48.5, 51], unit: "in" },
        { size: "S", waist: [66, 71], hips: [91, 97], unit: "cm" },
        { size: "M", waist: [71, 76], hips: [97, 102], unit: "cm" },
        { size: "L", waist: [77, 83], hips: [102, 107], unit: "cm" },
        { size: "XL", waist: [85, 91], hips: [108, 114], unit: "cm" },
        { size: "XXL", waist: [94, 100], hips: [116, 122], unit: "cm" },
        { size: "3XL", waist: [102, 108], hips: [123, 130], unit: "cm" },
      ],
    },
    "seamless-waist-support-brief-bodysuit": {
      category: "bodysuits",
      requiredMeasurements: ["overBust", "waist", "hips"],
      sizeChart: [
        { size: "XS", overBust: [32, 34], waist: [25, 27], hips: [35, 37], unit: "in" },
        { size: "S", overBust: [34, 36], waist: [28, 30], hips: [38, 40], unit: "in" },
        { size: "M", overBust: [36, 38], waist: [31, 33], hips: [41, 43], unit: "in" },
        { size: "L", overBust: [38, 40], waist: [34, 36], hips: [44, 46], unit: "in" },
        { size: "XL", overBust: [40, 42], waist: [37, 39], hips: [47, 49], unit: "in" },
        { size: "XXL", overBust: [42, 44], waist: [40, 42], hips: [50, 52], unit: "in" },
        { size: "3XL", overBust: [44, 46], waist: [43, 45], hips: [53, 55], unit: "in" },
        { size: "XS", overBust: [81, 86], waist: [64, 69], hips: [89, 94], unit: "cm" },
        { size: "S", overBust: [86, 91], waist: [71, 76], hips: [97, 102], unit: "cm" },
        { size: "M", overBust: [91, 97], waist: [79, 84], hips: [104, 109], unit: "cm" },
        { size: "L", overBust: [97, 102], waist: [86, 91], hips: [112, 117], unit: "cm" },
        { size: "XL", overBust: [102, 107], waist: [94, 99], hips: [119, 124], unit: "cm" },
        { size: "XXL", overBust: [107, 112], waist: [102, 107], hips: [127, 132], unit: "cm" },
        { size: "3XL", overBust: [112, 117], waist: [109, 114], hips: [135, 140], unit: "cm" },
      ],
    },
  };

  const GENERATED_PRODUCT_CONFIGS = window.__SELF_PRODUCT_SIZE_CHARTS__ || {};

  const normalize = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "");

  const normalizeSize = (value) => {
    const normalized = normalize(value);
    const aliases = {
      xxl: "2xl",
      xxxl: "3xl",
      xxxxl: "4xl",
      xxxxxl: "5xl",
    };
    return aliases[normalized] || normalized;
  };

  const toInches = (value, unit) => (unit === "cm" ? value / 2.54 : value);

  const labelToMeasurement = (label) => {
    const key = normalize(label);
    if (key.includes("underbust") || key.includes("band")) return "underBust";
    if (key.includes("overbust") || key === "bust" || key.includes("fullbust"))
      return "overBust";
    if (key.includes("waist")) return "waist";
    if (key.includes("hip")) return "hips";
    if (key.includes("length")) return "length";
    if (key.includes("cup")) return "cup";
    if (key.includes("size")) return "size";
    return "";
  };

  const parseRange = (value) => {
    if (Array.isArray(value) && value.length >= 2) {
      const min = Number.parseFloat(value[0]);
      const max = Number.parseFloat(value[1]);
      if (Number.isFinite(min) && Number.isFinite(max)) {
        return [Math.min(min, max), Math.max(min, max)];
      }
    }

    if (typeof value === "number" && Number.isFinite(value))
      return [value, value];
    const matches = String(value || "").match(/\d+(?:\.\d+)?/g);
    if (!matches || !matches.length) return null;
    const numbers = matches.map(Number).filter(Number.isFinite);
    if (!numbers.length) return null;
    if (numbers.length === 1) return [numbers[0], numbers[0]];
    return [Math.min(numbers[0], numbers[1]), Math.max(numbers[0], numbers[1])];
  };

  const braSizeLetterIndex = (braSize) => {
    const match = String(braSize || "")
      .trim()
      .match(/^(\d{2,3})\s*([A-Za-z]+)$/);
    if (!match) return null;
    const index = CUP_LETTERS.indexOf(match[2].toUpperCase());
    return index >= 0 ? index + 1 : null;
  };

  const getProductBraSizes = (product, unit) => {
    const sizes = new Set();
    getConfiguredChart(product, unit).forEach((row) => {
      (row.cupSizes || []).forEach((size) => sizes.add(String(size).trim()));
    });
    return Array.from(sizes).sort((a, b) => {
      const bandA = Number.parseInt(a, 10);
      const bandB = Number.parseInt(b, 10);
      if (bandA !== bandB) return bandA - bandB;
      return (braSizeLetterIndex(a) || 0) - (braSizeLetterIndex(b) || 0);
    });
  };

  const rangeContains = (range, value) => {
    return Array.isArray(range) && value >= range[0] && value <= range[1];
  };

  const rangeDistance = (range, value) => {
    if (!Array.isArray(range)) return Number.POSITIVE_INFINITY;
    if (rangeContains(range, value)) return 0;
    return value < range[0] ? range[0] - value : value - range[1];
  };

  const normalizeSizeChartRows = (product) => {
    const config =
      product.customConfig || PRODUCT_CONFIGS[product.handle] || {};
    const sourceRows = Array.isArray(config.sizeChart)
      ? config.sizeChart
      : Array.isArray(config.ranges)
        ? config.ranges
        : Array.isArray(product.metafieldChart)
          ? product.metafieldChart
          : [];
    const rows = sourceRows.length ? sourceRows : product.sizeChartRows || [];
    const columns = product.sizeChartColumns || {};

    return rows
      .map((row) => {
        const normalized = {
          size: row.size || row.label || row.name || row.title || "",
          variant: row.variant || row.variantTitle || row.variantOption || "",
          measurements: {},
          unit: row.unit || config.unit || "in",
        };

        if (Array.isArray(row.cupSizes) && row.cupSizes.length) {
          normalized.cupSizes = row.cupSizes;
        } else if (Array.isArray(row.cups) && row.cups.length && row.cups.every((entry) => typeof entry === "string")) {
          normalized.cupSizes = row.cups;
        }

        Object.keys(row).forEach((key) => {
          if (key === "cupSizes" || key === "cups") return;
          const measurement = labelToMeasurement(key);
          if (!measurement || measurement === "size") return;
          const range = parseRange(row[key]);
          if (range) normalized.measurements[measurement] = range;
        });

        [
          ["col2", columns.col2],
          ["col3", columns.col3],
          ["col4", columns.col4],
        ].forEach(([columnKey, label]) => {
          const measurement = labelToMeasurement(label);
          if (!measurement || measurement === "size") return;
          const range = parseRange(row[columnKey]);
          if (range) normalized.measurements[measurement] = range;
        });

        return normalized;
      })
      .filter((row) => row.size && Object.keys(row.measurements).length);
  };

  const getConfiguredChart = (product, unit) => {
    const rows = normalizeSizeChartRows(product);
    if (!unit) return rows;
    const unitRows = rows.filter((row) => row.unit === unit);
    return unitRows.length ? unitRows : rows;
  };

  const getJson = (modal) => {
    const script = modal.querySelector("[data-size-finder-config]");
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || "{}");
    } catch (error) {
      return null;
    }
  };

  const getGuideViewer = () => {
    let viewer = document.querySelector("[data-size-finder-guide-viewer]");
    if (viewer) return viewer;

    viewer = document.createElement("div");
    viewer.className = "product-size-finder-guide-viewer";
    viewer.setAttribute("data-size-finder-guide-viewer", "");
    viewer.setAttribute("aria-hidden", "true");
    viewer.innerHTML = `
      <div class="product-size-finder-guide-viewer__overlay" data-size-finder-guide-viewer-close></div>
      <div class="product-size-finder-guide-viewer__dialog" role="dialog" aria-modal="true" aria-label="Measurement guide image" tabindex="-1">
        <button class="product-size-finder-guide-viewer__close" type="button" data-size-finder-guide-viewer-close aria-label="Close measurement guide image">
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5 5 10 10M15 5 5 15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
        </button>
        <img src="" alt="">
      </div>
    `;
    document.body.appendChild(viewer);

    viewer
      .querySelectorAll("[data-size-finder-guide-viewer-close]")
      .forEach((button) => {
        button.addEventListener("click", () => closeGuideViewer());
      });

    viewer.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeGuideViewer();
    });

    return viewer;
  };

  const openGuideViewer = (image, opener) => {
    if (!image) return;
    const viewer = getGuideViewer();
    const viewerImage = viewer.querySelector("img");
    if (!viewerImage) return;

    viewerImage.src = image.currentSrc || image.src;
    viewerImage.alt = image.alt || "Measurement guide image";
    viewer.classList.add("is-open");
    viewer.setAttribute("aria-hidden", "false");
    viewer._guideViewerOpener = opener || document.activeElement;
    const dialog = viewer.querySelector(".product-size-finder-guide-viewer__dialog");
    if (dialog) dialog.focus();
  };

  const closeGuideViewer = () => {
    const viewer = document.querySelector("[data-size-finder-guide-viewer]");
    if (!viewer) return;
    viewer.classList.remove("is-open");
    viewer.setAttribute("aria-hidden", "true");
    const image = viewer.querySelector("img");
    if (image) image.removeAttribute("src");
    if (
      viewer._guideViewerOpener &&
      typeof viewer._guideViewerOpener.focus === "function"
    ) {
      viewer._guideViewerOpener.focus();
    }
  };

  const getCategory = (product) => {
    const explicitCategory = String(product.category || "").toLowerCase();
    if (["bras", "underwear", "tanks-camis", "bodysuits"].includes(explicitCategory)) {
      return explicitCategory;
    }

    const haystack = [
      product.handle,
      product.title,
      product.type,
      ...(product.tags || []),
      ...(product.collections || []),
    ]
      .join(" ")
      .toLowerCase();

    if (haystack.includes("bra")) return "bras";
    if (haystack.includes("bodysuit")) return "bodysuits";
    if (
      haystack.includes("underwear") ||
      haystack.includes("brief") ||
      haystack.includes("thong")
    )
      return "underwear";
    if (haystack.includes("tank") || haystack.includes("cami"))
      return "tanks-camis";
    return "default";
  };

  const bindApprovedDesktopChart = (modal) => {
    const guide = modal.querySelector("[data-size-finder-guide-image]");
    const root = modal.closest(".shopify-section") || modal.parentElement;
    const card = root?.querySelector(".self-figma-pdp__size-chart-card");
    const table = card?.querySelector("[data-pdp-size-chart]");
    const controls = card?.querySelectorAll("[data-pdp-size-unit]");
    if (!guide || !card || !table || !controls?.length) return;

    const sources = {
      in: guide.dataset.inchesGuide,
      cm: guide.dataset.cmGuide,
    };
    if (!sources.in || !sources.cm) return;

    let approvedChart = card.querySelector(
      "[data-approved-size-chart], [data-pdp-size-chart-image]",
    );
    if (!approvedChart) {
      approvedChart = document.createElement("img");
      approvedChart.className = "self-figma-pdp__approved-size-chart";
      approvedChart.loading = "lazy";
      approvedChart.alt = `${modal.dataset.productTitle || "Product"} size chart in inches`;
      table.insertAdjacentElement("afterend", approvedChart);
    }
    approvedChart.dataset.approvedSizeChart = "";

    const showUnit = (unit) => {
      approvedChart.src = sources[unit];
      approvedChart.alt = `${modal.dataset.productTitle || "Product"} size chart in ${unit === "cm" ? "centimeters" : "inches"}`;
      approvedChart.dataset.unit = unit;
      table.hidden = true;
      controls.forEach((control) => {
        const isActive = control.dataset.pdpSizeUnit === unit;
        control.classList.toggle("is-active", isActive);
        control.setAttribute("aria-selected", isActive ? "true" : "false");
      });
    };

    controls.forEach((control) => {
      control.addEventListener("click", () => showUnit(control.dataset.pdpSizeUnit));
    });
    showUnit("in");
  };

  const getRequiredMeasurements = (product, category) => {
    if (
      product.customConfig &&
      Array.isArray(product.customConfig.requiredMeasurements)
    ) {
      return product.customConfig.requiredMeasurements;
    }

    const chart = getConfiguredChart(product);
    if (chart.length) {
      const ordered = ["overBust", "underBust", "cup", "waist", "hips", "length"];
      const chartMeasurements = new Set(
        chart.flatMap((row) => Object.keys(row.measurements || {})),
      );
      const requiredFromChart = ordered.filter((key) =>
        chartMeasurements.has(key),
      );
      if (requiredFromChart.length) return requiredFromChart;
    }

    if (category === "bras") return ["overBust", "underBust"];
    if (category === "underwear") return ["waist", "hips"];
    if (category === "bodysuits") return ["overBust", "waist", "hips"];
    if (category === "tanks-camis") return ["overBust", "waist", "hips"];

    return ["overBust", "waist", "hips"];
  };

  const getGuideImage = (modal, category, required, unit = "in") => {
    const image = modal.querySelector("[data-size-finder-guide-image]");
    if (!image) return;

    const unitSource = unit === "cm" ? image.dataset.cmGuide : image.dataset.inchesGuide;
    if (unitSource) {
      image.src = unitSource;
      return;
    }

    let source = image.dataset.bustWaistHipsGuide;
    if (category === "bras") source = image.dataset.braGuide;
    if (category === "underwear") source = image.dataset.underwearGuide;
    if (category === "tanks-camis" && required.length === 2)
      source = image.dataset.bustWaistGuide;
    if (source) image.src = source;
  };

  const setModalCopy = (modal, category) => {
    const guideTitle = modal.querySelector("[data-size-finder-guide-title]");
    const title = modal.querySelector("[data-size-finder-title]");
    const calcTitle = modal.querySelector(
      "[data-size-finder-calculator-title]",
    );
    const instructions = modal.querySelector("[data-size-finder-instructions]");

    if (category === "bras") {
      if (guideTitle) guideTitle.textContent = "Bra Size Guide";
      if (title) title.textContent = "Find your bra size";
      if (calcTitle) calcTitle.textContent = "Bra Size Calculator";
    } else {
      if (guideTitle) guideTitle.textContent = "Size Finder";
      if (title) title.textContent = "Find your perfect fit";
      if (calcTitle) calcTitle.textContent = "Size Calculator";
    }

    if (instructions) {
      instructions.textContent =
        "Enter your measurements in inches or centimeters into the fields below to find your perfect fit!";
    }
  };

  const getHelperText = (key, unit, category, product) => {
    if (key === "cup") {
      return getProductBraSizes(product, unit).length
        ? "Select your bra size"
        : "Choose the cup letter that fits you best";
    }
    if (product) {
      const rows = getConfiguredChart(product, unit);
      const ranges = rows
        .map((row) => row.measurements && row.measurements[key])
        .filter((range) => Array.isArray(range));
      if (ranges.length) {
        const min = Math.min(...ranges.map((range) => range[0]));
        const max = Math.max(...ranges.map((range) => range[1]));
        return `Use numbers ${min} - ${max}`;
      }
    }
    if (category !== "bras")
      return unit === "cm"
        ? "Use decimal numbers in centimeters"
        : "Use decimal numbers in inches";
    if (key === "overBust" && unit === "in") return "Use numbers 27 - 47";
    if (key === "underBust" && unit === "in") return "Use numbers 27 - 40";
    if (key === "overBust" && unit === "cm") return "Use numbers 69 - 119";
    if (key === "underBust" && unit === "cm") return "Use numbers 69 - 102";
    return "";
  };

  const renderFields = (modal, state) => {
    const wrap = modal.querySelector("[data-size-finder-fields]");
    if (!wrap) return;
    wrap.innerHTML = "";

    state.required.forEach((key) => {
      let meta = MEASUREMENTS[key] || {
        label: key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (char) => char.toUpperCase()),
        placeholder: `Enter your ${key}`,
      };
      if (
        key === "overBust" &&
        (state.category === "tanks-camis" || state.category === "bodysuits")
      ) {
        meta = { label: "Bust", placeholder: "Enter your bust" };
      }
      const field = document.createElement("div");
      field.className = "product-size-finder__field";
      if (key === "cup") {
        const braSizes = getProductBraSizes(state.product, state.unit);
        const options = braSizes.length
          ? braSizes.map(
              (size) =>
                `<option value="${size}"${state.values[key] === size ? " selected" : ""}>${size}</option>`,
            ).join("")
          : CUP_LETTERS.map(
              (letter, index) =>
                `<option value="${index + 1}"${Number(state.values[key]) === index + 1 ? " selected" : ""}>${letter}</option>`,
            ).join("");
        field.innerHTML = `
        <label for="size-finder-${state.product.id}-${key}">${meta.label}</label>
        <div class="product-size-finder__field-control">
          <select id="size-finder-${state.product.id}-${key}" data-size-finder-input="${key}" aria-label="${meta.label}">
            <option value="">${meta.placeholder}</option>
            ${options}
          </select>
        </div>
        <span class="product-size-finder__hint">${getHelperText(key, state.unit, state.category, state.product)}</span>
      `;
      } else {
        field.innerHTML = `
        <label for="size-finder-${state.product.id}-${key}">${meta.label} (${state.unit === "cm" ? "cm" : "inches"})</label>
        <div class="product-size-finder__field-control">
          <input id="size-finder-${state.product.id}-${key}" inputmode="decimal" type="number" min="0" step="0.1" placeholder="${meta.placeholder}" data-size-finder-input="${key}" value="${state.values[key] || ""}">
          <span class="product-size-finder__stepper" aria-hidden="false">
            <button type="button" data-size-finder-step="${key}" data-step-direction="1" aria-label="Increase ${meta.label}">▲</button>
            <button type="button" data-size-finder-step="${key}" data-step-direction="-1" aria-label="Decrease ${meta.label}">▼</button>
          </span>
        </div>
        <span class="product-size-finder__hint">${getHelperText(key, state.unit, state.category, state.product)}</span>
      `;
      }
      wrap.appendChild(field);
    });
  };

  const readValues = (modal, state) => {
    modal.querySelectorAll("[data-size-finder-input]").forEach((input) => {
      state.values[input.dataset.sizeFinderInput] = input.value;
    });
  };

  const getNumericValues = (state) => {
    return state.required.reduce((acc, key) => {
      if (key === "cup") {
        const raw = String(state.values[key] || "").trim();
        const letterIndex = braSizeLetterIndex(raw);
        if (letterIndex) {
          // Bra-size selection like "34B": validate as present and keep the
          // letter index for range matching plus the full size for list matching.
          acc[key] = letterIndex;
          acc[`${key}Inches`] = letterIndex;
          acc.cupSize = raw.replace(/\s+/g, "").toUpperCase();
          return acc;
        }
      }
      const raw = Number.parseFloat(state.values[key]);
      acc[key] = Number.isFinite(raw) ? raw : null;
      acc[`${key}Inches`] = Number.isFinite(raw)
        ? key === "cup"
          ? raw
          : toInches(raw, state.unit)
        : null;
      return acc;
    }, {});
  };

  const validate = (state) => {
    const values = getNumericValues(state);
    const hasAllValues = state.required.every(
      (key) => values[key] !== null && values[key] > 0,
    );
    if (!hasAllValues) return { valid: false, message: "", warning: false };

    const chartRows = getConfiguredChart(state.product, state.unit);
    const hasRequiredChart = chartRows.some((row) =>
      state.required.every((measurement) =>
        rowCoversMeasurement(row, measurement),
      ),
    );
    if (!hasRequiredChart) {
      return {
        valid: false,
        message:
          "This product needs a product-specific size chart before Size Finder can calculate a recommendation.",
        warning: false,
      };
    }

    if (
      state.category === "bras" &&
      values.overBustInches <= values.underBustInches
    ) {
      return {
        valid: false,
        message:
          "The Over bust size should be greater than the underbust size",
        warning: false,
      };
    }

    if (
      state.category === "underwear" &&
      values.hipsInches <= values.waistInches
    ) {
      return {
        valid: false,
        message: "Hip Size Must Be Bigger than Waist",
        warning: false,
      };
    }

    if (state.category === "tanks-camis") {
      if (
        state.required.includes("hips") &&
        (values.waistInches >= values.overBustInches ||
          values.waistInches >= values.hipsInches)
      ) {
        return {
          valid: false,
          message:
            "Your waist measurement should be  smaller than both your bust and hip measurements",
          warning: false,
        };
      }
      if (
        !state.required.includes("hips") &&
        values.waistInches >= values.overBustInches
      ) {
        return {
          valid: false,
          message:
            "Your waist measurement should be  smaller than your bust measurement.",
          warning: false,
        };
      }
    }

    if (
      state.category === "bodysuits" &&
      (values.waistInches >= values.overBustInches ||
        values.waistInches >= values.hipsInches)
    ) {
      return {
        valid: true,
        message:
          "Please double-check your measurements. Your waist measurement is usually smaller than your bust and hip measurements. Continue if your measurements are correct.",
        warning: true,
      };
    }

    return { valid: true, message: "", warning: false };
  };

  const getRowMeasurementRangeInInches = (row, measurement) => {
    const range = row.measurements && row.measurements[measurement];
    if (!range) return null;
    if (row.unit === "cm") return range.map((value) => value / 2.54);
    return range;
  };

  const rowHasCupSizes = (row) =>
    Array.isArray(row.cupSizes) && row.cupSizes.length > 0;

  const rowCoversMeasurement = (row, measurement) =>
    measurement === "cup" && rowHasCupSizes(row)
      ? true
      : Boolean(getRowMeasurementRangeInInches(row, measurement));

  const cupListMatches = (row, values) => {
    if (values.cupSize) {
      return row.cupSizes.some(
        (size) =>
          String(size).replace(/\s+/g, "").toUpperCase() === values.cupSize,
      );
    }
    if (values.cupInches != null) {
      return row.cupSizes.some(
        (size) => braSizeLetterIndex(size) === values.cupInches,
      );
    }
    return false;
  };

  const cupListDistance = (row, values) => {
    const clean = (size) =>
      String(size)
        .replace(/\s+/g, "")
        .toUpperCase();
    if (values.cupSize) {
      const selected = values.cupSize.match(/^(\d+)([A-Z]+)$/);
      if (selected) {
        const band = Number(selected[1]);
        const letterIndex = CUP_LETTERS.indexOf(selected[2]) + 1;
        return Math.min(
          ...row.cupSizes.map((size) => {
            const entry = clean(size).match(/^(\d+)([A-Z]+)$/);
            return (
              Math.abs(Number(entry[1]) - band) / 4 +
              Math.abs(CUP_LETTERS.indexOf(entry[2]) + 1 - letterIndex)
            );
          }),
        );
      }
    }
    if (values.cupInches != null) {
      return Math.min(
        ...row.cupSizes.map((size) =>
          Math.abs((braSizeLetterIndex(size) || 0) - values.cupInches),
        ),
      );
    }
    return Number.POSITIVE_INFINITY;
  };

  const findBestChartRow = (state) => {
    const values = getNumericValues(state);
    const chart = getConfiguredChart(state.product, state.unit);
    let usableRows = chart.filter((row) => {
      return state.required.every((measurement) =>
        rowCoversMeasurement(row, measurement),
      );
    });

    if (!usableRows.length) return null;

    const configuredRows = usableRows.filter((row) => {
      const option = row.variant || row.size;
      const match = String(option).match(/^(\d{2,3})\s*([A-Za-z].*)$/);
      const recommendation = {
        display: row.size,
        size: option,
        combined: option,
        band: match ? match[1] : "",
        cup: match ? match[2].replace(/\s+/g, "") : "",
      };
      return getRecommendationCandidates(state.product, recommendation).some(
        (variant) => variant.available,
      );
    });

    if (configuredRows.length) usableRows = configuredRows;

    const exact = usableRows.find((row) =>
      state.required.every((measurement) => {
        if (measurement === "cup" && rowHasCupSizes(row)) {
          return cupListMatches(row, values);
        }
        const range = getRowMeasurementRangeInInches(row, measurement);
        return rangeContains(range, values[`${measurement}Inches`]);
      }),
    );
    if (exact) return exact;

    return usableRows
      .map((row) => {
        const distance = state.required.reduce((total, measurement) => {
          if (measurement === "cup" && rowHasCupSizes(row)) {
            return total + cupListDistance(row, values);
          }
          const range = getRowMeasurementRangeInInches(row, measurement);
          return total + rangeDistance(range, values[`${measurement}Inches`]);
        }, 0);
        return { row, distance };
      })
      .sort((a, b) => a.distance - b.distance)[0].row;
  };

  const calculateChartSize = (state) => {
    const row = findBestChartRow(state);
    if (!row) return null;
    return {
      display: row.size,
      size: row.variant || row.size,
      chartSize: row.size,
    };
  };

  const calculateBraSize = (state) => {
    const chartRecommendation = calculateChartSize(state);
    if (chartRecommendation) {
      const option = chartRecommendation.size;
      const match = String(option).match(/^(\d{2,3})\s*([A-Za-z].*)$/);
      return {
        ...chartRecommendation,
        combined: option,
        band: match ? match[1] : "",
        cup: match ? match[2].replace(/\s+/g, "") : "",
      };
    }

    return null;
  };

  const getRecommendationCandidates = (product, recommendation) => {
    const variants = product.variants || [];
    const combined = normalize(recommendation.combined || "");
    const band = normalize(recommendation.band || "");
    const cup = normalize(recommendation.cup || "");
    const size = normalizeSize(
      recommendation.size || recommendation.display || recommendation,
    );
    const sizeAliases = new Set([size]);
    String(recommendation.size || recommendation.display || "")
      .split("/")
      .map(normalizeSize)
      .filter(Boolean)
      .forEach((alias) => sizeAliases.add(alias));

    if (band) {
      const bandNumber = Number.parseInt(band, 10);
      const alphaSizes = ["s", "m", "l", "xl", "2xl", "3xl", "4xl", "5xl"];
      if (Number.isFinite(bandNumber)) {
        const alphaIndex = Math.max(0, Math.min(alphaSizes.length - 1, Math.floor((bandNumber - 32) / 2)));
        sizeAliases.add(alphaSizes[alphaIndex]);
      }
    }

    const exact = variants.filter((variant) => {
      const options = (variant.options || []).map(normalizeSize);
      if (product.handle === 'soft-support-wireless-bra') return options.includes(size);
      if (
        combined &&
        options.some(
          (option) => option === combined || option.includes(combined),
        )
      )
        return true;
      if (band && cup && options.includes(band) && options.includes(cup))
        return true;
      if (cup && options.includes(cup)) return true;
      return Array.from(sizeAliases).some((alias) => options.includes(alias));
    });

    if (exact.length) return exact;

    return variants.filter((variant) => {
      const title = normalizeSize(variant.title);
      return (
        (combined && title.includes(combined)) ||
        Array.from(sizeAliases).some((alias) => title.includes(alias))
      );
    });
  };

  const findVariantForRecommendation = (product, recommendation) =>
    getRecommendationCandidates(product, recommendation)[0];

  const getCurrentOptions = (section) => {
    const options = [];
    section
      .querySelectorAll(
        "[data-pdp-option].is-active, .self-option-button.is-active",
      )
      .forEach((button) => {
        const index = Number(button.getAttribute("data-option-index"));
        options[index] = button.getAttribute("data-option-value");
      });
    return options;
  };

  const preferCurrentOptions = (section, product, recommendation) => {
    const candidates = getRecommendationCandidates(product, recommendation);
    if (!candidates.length) return null;
    const currentOptions = getCurrentOptions(section);
    const availableCandidates = candidates.filter((variant) => variant.available);
    return (availableCandidates.length ? availableCandidates : candidates)
      .map((variant) => ({
        variant,
        score: (variant.options || []).reduce((total, option, index) => {
          if (!currentOptions[index]) return total;
          return (
            total +
            (normalizeSize(currentOptions[index]) === normalizeSize(option) ? 1 : 0)
          );
        }, 0),
      }))
      .sort((a, b) => b.score - a.score)[0].variant;
  };

  const updateVisibleVariantState = (section, variantId) => {
    const variantScript = section.querySelector("[data-pdp-variants]");
    if (!variantScript) return;

    let variants = [];
    try {
      variants = JSON.parse(variantScript.textContent || "[]");
    } catch (error) {
      variants = [];
    }

    const variant = variants.find(
      (item) => String(item.id) === String(variantId),
    );
    if (!variant) return;

    const submit = section.querySelector(
      "[data-pdp-submit], [data-self-submit]",
    );
    const stickySubmit = document.querySelector("[data-pdp-sticky-submit]");
    const priceCurrent = section.querySelector("[data-pdp-price-current]");
    const priceCompare = section.querySelector("[data-pdp-price-compare]");
    const stickyPrice = document.querySelector("[data-pdp-sticky-price]");
    const unitPrice = section.querySelector("[data-pdp-unit-price]");
    const saleBadge = section.querySelector("[data-pdp-sale-badge]");
    const skuWrap = section.querySelector("[data-pdp-sku-wrap]");
    const skuText = section.querySelector("[data-pdp-sku]");
    const barcodeWrap = section.querySelector("[data-pdp-barcode-wrap]");
    const barcodeText = section.querySelector("[data-pdp-barcode]");
    const inventoryText = section.querySelector("[data-pdp-inventory]");

    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available
        ? submit.getAttribute("data-add-text") || submit.textContent
        : submit.getAttribute("data-sold-text") || "Sold out";
    }
    if (stickySubmit) stickySubmit.disabled = !variant.available;
    if (priceCurrent && variant.price) priceCurrent.textContent = variant.price;
    if (stickyPrice && variant.price) stickyPrice.textContent = variant.price;
    if (priceCompare) {
      priceCompare.textContent = variant.compare || "";
      priceCompare.classList.toggle("hidden", !variant.compare);
    }
    if (unitPrice && "unitPrice" in variant) {
      unitPrice.innerHTML = variant.unitPrice || "";
      unitPrice.classList.toggle("hidden", !variant.unitPrice);
    }
    if (saleBadge) {
      saleBadge.textContent = variant.saleBadge || "";
      saleBadge.classList.toggle("hidden", !variant.saleBadge);
    }
    if (skuText) skuText.textContent = variant.sku || "";
    if (skuWrap) skuWrap.classList.toggle("hidden", !variant.sku);
    if (barcodeText) barcodeText.textContent = variant.barcode || "";
    if (barcodeWrap) barcodeWrap.classList.toggle("hidden", !variant.barcode);
    if (inventoryText && "inventory" in variant) {
      inventoryText.textContent = variant.available
        ? "In stock"
        : "Out of stock";
    }
  };

  const activateStaticBraSelectors = (section, recommendation) => {
    if (!recommendation.band && !recommendation.cup) return;

    section.querySelectorAll("[data-pdp-static-option]").forEach((group) => {
      const values = Array.from(
        group.querySelectorAll("[data-pdp-static-value]"),
      );
      const target = values.find((button) => {
        const text = normalize(button.textContent);
        return (
          text === normalize(recommendation.band) ||
          text === normalize(recommendation.cup) ||
          text.includes(normalize(recommendation.cup))
        );
      });
      if (!target || target.classList.contains("is-unavailable")) return;

      values.forEach((button) => {
        const active = button === target;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });
    });
  };

  const selectVariant = (modal, product, recommendation) => {
    const section =
      modal.closest("section") ||
      document
        .querySelector("[data-self-figma-pdp], [data-self-product-form]")
        ?.closest("section") ||
      document;
    const variant = preferCurrentOptions(section, product, recommendation);
    if (!variant) return false;

    (variant.options || []).forEach((option, index) => {
      const button = Array.from(
        section.querySelectorAll(`[data-option-index="${index}"]`),
      ).find((candidate) => {
        return candidate.getAttribute("data-option-value") === option;
      });
      if (button && !button.disabled) {
        button.click();
      }
    });

    const variantInput = section.querySelector(
      '[data-pdp-variant-id], [data-self-product-form] input[name="id"], form[action*="/cart/add"] input[name="id"]',
    );
    if (variantInput) {
      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    activateStaticBraSelectors(section, recommendation);
    updateVisibleVariantState(section, variant.id);

    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      url.searchParams.delete("open-size-finder");
      url.searchParams.delete("size_finder");
      if (url.hash === "#size-finder") url.hash = "";
      window.history.replaceState({ path: url.toString() }, "", url.toString());
    }

    section.dispatchEvent(
      new CustomEvent("size-finder:variant-selected", {
        detail: { variant, recommendation },
      }),
    );
    return true;
  };

  const setValidationState = (modal, state) => {
    readValues(modal, state);
    const status = validate(state);
    const message = modal.querySelector("[data-size-finder-message]");
    const submit = modal.querySelector("[data-size-finder-submit]");
    if (message) {
      message.textContent = status.message || "";
      message.classList.toggle("is-warning", Boolean(status.warning));
    }
    if (submit) submit.disabled = !status.valid;
    return status;
  };

  const showResult = (modal, state, recommendation) => {
    state.recommendation = recommendation;
    const result = modal.querySelector("[data-size-finder-result]");
    const size = modal.querySelector("[data-size-finder-result-size]");
    if (size)
      size.textContent =
        recommendation.display ||
        recommendation.size ||
        recommendation.combined ||
        recommendation;
    if (result) result.hidden = false;
  };

  const openModal = (modal, opener) => {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    modal._sizeFinderOpener = opener || document.activeElement;
    document.documentElement.style.overflow = "hidden";
    const dialog = modal.querySelector(".product-size-finder__dialog");
    if (dialog) dialog.focus();
  };

  const closeModal = (modal) => {
    closeGuideViewer();
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    if (
      modal._sizeFinderOpener &&
      typeof modal._sizeFinderOpener.focus === "function"
    ) {
      modal._sizeFinderOpener.focus();
    }
  };

  const bindModal = async (modal) => {
    if (modal.dataset.sizeFinderReady === "true") return;
    modal.dataset.sizeFinderReady = "true";

    const json = getJson(modal);
    if (!json || !json.product) return;

    if (typeof json.product.customConfig === "string") {
      try {
        json.product.customConfig = JSON.parse(json.product.customConfig);
      } catch (error) {
        json.product.customConfig = null;
      }
    }

    if (typeof json.product.sectionConfig === "string") {
      try {
        json.product.sectionConfig = JSON.parse(json.product.sectionConfig);
      } catch (error) {
        json.product.sectionConfig = null;
      }
    }

    if (!json.product.customConfig && json.product.sectionConfig) {
      const sectionOverride = json.product.sectionConfig[json.product.handle];
      if (sectionOverride) json.product.customConfig = sectionOverride;
    }

    if (!json.product.customConfig) {
      json.product.customConfig =
        PRODUCT_CONFIGS[json.product.handle] ||
        GENERATED_PRODUCT_CONFIGS[json.product.handle] ||
        null;
    }

    if (json.product.handle === 'soft-support-wireless-bra' && modal.dataset.variantsModule) {
      try {
        const { loadProductVariants } = await import(modal.dataset.variantsModule);
        const nodes = await loadProductVariants(json.product.handle);
        if (!modal.isConnected) return;
        json.product.variants = nodes.map((node) => ({
          id: node.id.split('/').pop(), title: node.title, available: node.availableForSale,
          options: node.selectedOptions.map((option) => option.value),
        }));
      } catch (error) {
        console.warn('Unable to load size-finder variants', error);
      }
    }

    const state = {
      product: json.product,
      category:
        json.product.customConfig?.category || getCategory(json.product),
      unit: "in",
      values: {},
      recommendation: null,
    };
    state.required = getRequiredMeasurements(state.product, state.category);

    setModalCopy(modal, state.category);
    getGuideImage(modal, state.category, state.required, state.unit);
    bindApprovedDesktopChart(modal);
    renderFields(modal, state);
    setValidationState(modal, state);

    modal
      .querySelectorAll("[data-product-size-finder-close]")
      .forEach((button) => {
        button.addEventListener("click", () => closeModal(modal));
      });

    modal.querySelectorAll("[data-size-finder-unit]").forEach((button) => {
      button.addEventListener("click", () => {
        readValues(modal, state);
        const previousUnit = state.unit;
        state.unit = button.dataset.sizeFinderUnit;
        if (previousUnit !== state.unit) {
          Object.keys(state.values).forEach((key) => {
            const value = Number.parseFloat(state.values[key]);
            if (!Number.isFinite(value)) return;
            const converted =
              state.unit === "cm" ? value * 2.54 : value / 2.54;
            state.values[key] = converted.toFixed(1);
          });
        }
        modal
          .querySelectorAll("[data-size-finder-unit]")
          .forEach((unitButton) => {
            const isActive = unitButton === button;
            unitButton.classList.toggle("is-active", isActive);
            unitButton.setAttribute(
              "aria-selected",
              isActive ? "true" : "false",
            );
          });
        renderFields(modal, state);
        getGuideImage(modal, state.category, state.required, state.unit);
        setValidationState(modal, state);
      });
    });

    const onFinderInput = (event) => {
      if (!event.target.matches("[data-size-finder-input]")) return;
      setValidationState(modal, state);
    };
    modal.addEventListener("input", onFinderInput);
    modal.addEventListener("change", onFinderInput);

    modal.addEventListener("click", (event) => {
      const guideZoom = event.target.closest("[data-size-finder-guide-zoom]");
      if (guideZoom) {
        const guideImage =
          guideZoom.closest(".product-size-finder__guide")?.querySelector("img") ||
          modal.querySelector("[data-size-finder-guide-image]");
        openGuideViewer(guideImage, guideZoom);
        return;
      }

      const stepper = event.target.closest("[data-size-finder-step]");
      if (!stepper) return;
      const key = stepper.dataset.sizeFinderStep;
      const input = modal.querySelector(`[data-size-finder-input="${key}"]`);
      if (!input) return;
      const direction = Number(stepper.dataset.stepDirection) || 1;
      const current = Number.parseFloat(input.value) || 0;
      input.value = Math.max(0, current + direction * 0.1).toFixed(1);
      setValidationState(modal, state);
    });

    const form = modal.querySelector("[data-size-finder-form]");
    if (form) {
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        const status = setValidationState(modal, state);
        if (!status.valid) return;
        const recommendation =
          state.category === "bras"
            ? calculateBraSize(state)
            : calculateChartSize(state);
        if (!recommendation) {
          const message = modal.querySelector("[data-size-finder-message]");
          if (message) {
            message.textContent =
              "No matching size was found in this product's size chart.";
          }
          return;
        }
        showResult(modal, state, recommendation);
      });
    }

    const shop = modal.querySelector("[data-size-finder-shop]");
    if (shop) {
      shop.addEventListener("click", () => {
        if (!state.recommendation) return;
        const selected = selectVariant(
          modal,
          state.product,
          state.recommendation,
        );
        if (selected) {
          closeModal(modal);
          return;
        }

        const message = modal.querySelector("[data-size-finder-message]");
        if (message) {
          message.textContent =
            "This recommended size is not currently configured as a Shopify variant for this product.";
          message.classList.remove("is-warning");
        }
      });
    }

    modal.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeModal(modal);
        return;
      }

      if (event.key !== "Tab") return;
      const focusable = Array.from(modal.querySelectorAll(FOCUSABLE)).filter(
        (element) => element.offsetParent !== null,
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  const getProductModalForOpener = (opener) => {
    const section = opener.closest("section");
    return section
      ? section.querySelector(MODAL_SELECTOR)
      : document.querySelector(MODAL_SELECTOR);
  };

  const shouldAutoOpenModal = () => {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get("open-size-finder") === "1" ||
      params.get("size_finder") === "open" ||
      window.location.hash === "#size-finder"
    );
  };

  const autoOpenModal = () => {
    if (!shouldAutoOpenModal()) return;
    if (document.documentElement.dataset.productSizeFinderAutoOpened === "true")
      return;

    const modal = document.querySelector(MODAL_SELECTOR);
    if (!modal) return;

    document.documentElement.dataset.productSizeFinderAutoOpened = "true";
    bindModal(modal);
    window.requestAnimationFrame(() => {
      openModal(
        modal,
        document.querySelector(OPEN_SELECTOR) || document.activeElement,
      );
    });
  };

  const init = () => {
    document.querySelectorAll(MODAL_SELECTOR).forEach(bindModal);
    autoOpenModal();
    document.addEventListener("click", (event) => {
      const opener = event.target.closest(OPEN_SELECTOR);
      if (!opener) return;
      const modal = getProductModalForOpener(opener);
      if (!modal) return;
      event.preventDefault();
      bindModal(modal);
      openModal(modal, opener);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
